<template>
  <div class="user-profile-header">
    <div class="container">
      <div class="user-info">
        <h2>Viewing the public Profile for:</h2>
        <h1 class="welcome-title">
          {{ user?.firstName }} {{ user?.lastName }}
          <span v-if="user.isSupervisorVerified" class="verified-badge"><i class="mdi mdi-shield-check"></i></span>
        </h1>
        <p class="tagline" v-if="user?.circleFields?.flattened_profile_fields?.headline || user?.headline">
          {{ user?.circleFields?.flattened_profile_fields?.headline || user?.circleFields?.headline || user?.headline }}
        </p>
      </div>

      <div class="header-controls">
        <!-- Avatar -->
        <div class="avatar-container" v-if="user?.circleFields?.avatar_url">
          <img
            :src="user.circleFields.avatar_url"
            alt="Profile Avatar"
            class="user-avatar"
            @error="handleAvatarError"
          />
        </div>
      </div>
    </div>
    <!-- Centered Copy Link Button -->
    <div v-if="self" class="copy-link-row">
      <b-button
        type="is-primary"
        size="is-large"
        class="copy-link-btn"
        @click="copyStatsheetLink"
      >
        <i class="mdi mdi-content-copy"></i>
        Copy my Profile Link
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsheetHeader',
  props: {
    user: {
      type: Object,
      required: true
    },
    self: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleAvatarError(e) {
      e.target.src = 'https://via.placeholder.com/150?text=User';
    },
    async runSemanticAnalysis() {
      try {
        await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/semantic-analysis`,
          {},
          {
            headers: {
              'Authorization': this.$cookies.get("teamwrkr-token")
            }
          }
        ).then(() => {
          this.$buefy.toast.open({
            message: 'Semantic analysis started successfully!',
            type: 'is-success',
            position: 'is-bottom',
          });
        });
      } catch(error) {
        console.error('Error marking notification as read:', error);
      }
    },
    async copyStatsheetLink() {
      const link = `${window.location.origin}/profile/${this.user?._id}`;
      try {
        await navigator.clipboard.writeText(link);
        this.$buefy.toast.open({
            message: 'Profile link copied to clipboard!',
          type: 'is-success',
          position: 'is-bottom',
        });
      } catch (err) {
        this.$buefy.toast.open({
          message: 'Failed to copy link.',
          type: 'is-danger',
          position: 'is-bottom',
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.user-profile-header {
  background-color: rgb(248, 249, 250);
  color: $color-primary;
  padding: 2rem 1.5rem;
  max-width: 1344px;
  margin: -2rem auto 0;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .user-info {
    flex: 1;
    text-align: left;

    .welcome-title {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
      text-align: left;
    }

    .tagline {
      font-size: 1.2rem;
      opacity: 0.9;
      margin: 0;
      text-align: left;
    }
  }
}

.copy-link-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.copy-link-btn {
  font-size: 1.25rem;
  font-weight: 700;
  padding: 1.1rem 2.2rem;
  border-radius: 2rem;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.08);
  display: flex;
  align-items: center;
  gap: 0.8rem;
  i {
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.avatar-container {
  .user-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3px solid white;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    object-fit: cover;
  }
}

@media screen and (max-width: 768px) {
  .user-profile-header {
    .container {
      flex-direction: column;
      text-align: left;
    }

    .header-controls {
      width: 100%;
      justify-content: center;
      margin-top: 1.5rem;
    }

    .user-info {
      width: 100%;
      text-align: left;

      .welcome-title {
        font-size: 1.8rem;
        text-align: left;
      }

      .tagline {
        font-size: 1rem;
        text-align: left;
      }
    }
  }

  .copy-link-row {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .copy-link-btn {
    font-size: 1.1rem;
    padding: 0.8rem 1.2rem;
    border-radius: 1.5rem;
    i {
      font-size: 1.2rem;
      margin-right: 0.4rem;
    }
  }
}
</style>
